export const menuSurfaceClass =
  'bg-n-alpha-3 backdrop-blur-[100px] border-0 outline outline-1 outline-n-container rounded-xl shadow-lg';

export const menuItemClass =
  'relative inline-flex shrink-0 w-full min-w-0 items-center justify-start gap-2 rounded-lg border-0 px-2 py-1.5 text-start text-sm transition-colors hover:bg-n-alpha-1 dark:hover:bg-n-alpha-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50';
